import { render, staticRenderFns } from "./buybuttonCompact.vue?vue&type=template&id=05fce524&scoped=true"
import script from "./buybuttonCompact.vue?vue&type=script&lang=js"
export * from "./buybuttonCompact.vue?vue&type=script&lang=js"
import style0 from "./buybuttonCompact.vue?vue&type=style&index=0&id=05fce524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fce524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fce524')) {
      api.createRecord('05fce524', component.options)
    } else {
      api.reload('05fce524', component.options)
    }
    module.hot.accept("./buybuttonCompact.vue?vue&type=template&id=05fce524&scoped=true", function () {
      api.rerender('05fce524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/buybuttonCompact.vue"
export default component.exports